import React, { useEffect, useState } from 'react';
import Badge from '@material-ui/core/Badge';

export default function StatusBadge(props)
{
    return <>{props.children}</>;
    
}